export default Object.freeze({
  home: {
    name: 'home',
    path: '/',
  },
  myAvailability: {
    name: 'myAvailability',
    path: '/availability',
  },
  clientOverview: {
    path: '/overview',
    name: 'client-overview',
  },
  clientGroupOverview: {
    path: '/group-overview',
    name: 'clientGroupOverview',
  },
  timesheets: {
    path: '/timesheets',
    name: 'timesheets',
  },
  candidates: {
    path: '/candidates',
    name: 'candidates',
  },
  help: {
    path: '/help',
    name: 'help',
  },
  bookings: {
    path: '/bookings',
  },
  bookingsCreate: {
    path: 'create',
    name: 'bookings-create',
  },
  settings: {
    name: 'settings',
    path: '/settings',
  },
  changePassword: {
    name: 'changePassword',
    path: '/settings/change-password',
  },
  login: {
    name: 'login',
    path: '/login',
  },
  impersonateLogout: {
    name: 'impersonateLogout',
    path: '/user/impersonate/logout',
  },
  impersonateLogin: {
    name: 'impersonateLogin',
    path: '/user/impersonate/:contactId',
  },
  finance: {
    name: 'finance',
    path: '/finance',
  },
  invoiceDetails: {
    path: '/finance/invoices/:invoiceNo',
    name: 'invoice-view',
  },
  logout: {
    name: 'logout',
    path: '/logout',
  },
  underConstruction: {
    name: 'underConstruction',
    path: '/under-construction',
  },
  notFound: {
    name: 'NotFoundPage',
    path: '/404',
  },
  error: {
    name: 'ErrorPage',
    path: '/500',
  },
  unauthorized: {
    name: 'UnauthorizedPage',
    path: '/401',
  },
  forbidden: {
    name: 'ForbiddenPage',
    path: '/403',
  },
  accountLoadFailure: {
    name: 'AccountLoadFailedPage',
  },
  noServerResponse: {
    name: 'NoServerResponsePage',
  },
  actionLocked: {
    name: 'accountLockedError',
  },
})
